import React, { useState, useEffect } from 'react';
import InputComponent from '../components/fields/InputComponent'
import { connect } from 'react-redux';

const YourColleaguesInvite  = React.memo((props) => {
    return <>
        <div className='inner-wrapper'>
                <div className="inner-title-success">{props.labels['corporate.signup.success.popup.title']}</div>
                {props.labels['corporate.signup.success.description']}

                <div className='smart-link-wrapper' >
                    <input type="text"  name="search" readonly className="smart-link-input " />
                    <button className='smart-link-copy-button btn-secondary' type="submit" id="link-copy"  >{props.labels['corporate.signup.copy.link']}</button>
                    <div  className="copied">{props.labels['corporate.signup.link.copied']}! </div>
                </div>
            </div>
        </>

});
const mapStateFromReducer = (state) => ({
    labels : state.corporateSignupReducer.labels || {},
    getSessionStorage : state.corporateSignupReducer.getSessionStorage || {}
})
export default connect(
    mapStateFromReducer,
    null
)(YourColleaguesInvite);

